import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {MatRipple} from '@angular/material/core';

/**
 * Icon Button UI
 * Styles a native `<button>` element as an Angular Material icon button.
 * The caller is responsible for providing the icon markup as content.
 *
 * Requires an Angular Material theme in the host application's global styles.
 *
 * @example
 *   <button epg-icon-button aria-label="Home">
 *     <span class="fas fa-home"></span>
 *   </button>
 */
@Component({
  selector: 'button[epg-icon-button]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  hostDirectives: [MatRipple],
  host: {
    class: 'mat-mdc-icon-button mat-mdc-button-base mdc-icon-button mat-unthemed',
  },
  templateUrl: './epg-icon-button.component.html',
  styleUrl: './epg-icon-button.component.scss',
})
export class EpgIconButtonComponent {}
